import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import styled from "styled-components";

const ManageSection = styled.section`
  background-image: url("/images/fondo3.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 30px 0;
  position: relative;
  overflow: hidden;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 10 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const Content = styled.div`
  background-image: url("/images/gestion-contenido1.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  z-index: 2;
  padding: 2rem;
  padding-left: 4rem;
  line-height: 0.9;

`;

const Title = styled(motion.h2)`
  font-family: "BRLNSDB";
  font-size: 2.5rem;
  color: rgb(255, 255, 255);
  margin-top: 7rem;
  position: relative;
  margin-bottom: 2rem;
  }
`;

const Description = styled(motion.p)`
  color: rgb(255, 255, 255);
  line-height: 1.8;
  font-size: 1rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
  font-family: "Montserrat";
  margin: 2rem;
  margin-bottom: 4rem;
`;

const ManageButton = styled(motion.a)`
  font-family: "BRLNSDB";
  background-image: url("/images/fondo2.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;
  padding: 1rem 2rem;
  color: white;
  text-decoration: none;
  border-radius: 30px;
  font-weight: 600;
  font-size: 1.5rem;
  box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  svg {
    width: 20px;
    height: 20px;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 30px rgba(102, 126, 234, 0.4);
  }
`;

const IllustrationWrapper = styled(motion.div)`
  position: relative;

  &:before {
    content: "";
    position: absolute;
    top: -20px;
    left: -20px;
    right: 20px;
    bottom: 20px;
    border: 2px solid #667eea;
    border-radius: 20px;
    z-index: 1;
  }
`;

const Illustration = styled(motion.img)`
  width: 100%;
  height: auto;
  border-radius: 20px;
  position: relative;
  z-index: 2;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
`;

const FloatingElements = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
`;

const FloatingIcon = styled(motion.div)`
  position: absolute;
  width: 50px;
  height: 50px;
  background: white;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
`;

const ManageContent = () => {
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  const floatingIcons = [
    { icon: "📝", top: "10%", left: "10%", delay: 0 },
    { icon: "📚", top: "20%", right: "10%", delay: 0.2 },
    { icon: "✏️", bottom: "20%", left: "15%", delay: 0.4 },
    { icon: "🎯", bottom: "10%", right: "15%", delay: 0.6 },
  ];

  return (
    <ManageSection id="manage-content" ref={ref}>
      <Container>
        <Content>
          <Title
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
          >
            Gestiona Contenido
          </Title>
          <Description
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Nuestra plataforma permite a los docentes ingresar y administrar
            contenido educativo, agregando nuevos recursos, actividades y
            material pedagógico. Además, los estudiantes pueden actualizar y
            enriquecer su aprendizaje accediendo a la información más reciente
            disponible en la plataforma.
          </Description>
        </Content>

        <Illustration
          src="/images/gestion-contenido2.png"
          alt="Gestión de Contenido"
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.3 }}
        />

        
      </Container>
      <ManageButton
          href="https://csi-ingenieria.com/pedlite-admin/vista/#/"
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.4 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 4L12 20M20 12L4 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
          Gestionar Contenido
        </ManageButton>
    </ManageSection>
  );
};

export default ManageContent;
